import { render, staticRenderFns } from "./wizard-selector.vue?vue&type=template&id=78f6d65e&"
import script from "./wizard-selector.vue?vue&type=script&lang=js&"
export * from "./wizard-selector.vue?vue&type=script&lang=js&"
import style0 from "./_wizard-selector.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports